import { apiClient } from "./apiClient";
export const komodoApi = {
    getConnection: () => apiClient.get("/settings/komodo"),
    upsertConnection: (payload) => apiClient.put("/settings/komodo", payload),
};
